<template>
  <div class="columns is-multiline">
    <div class="column is-12-mobile is-6-tablet is-4-desktop">
      <InputSelect
        name="Terzo responsabile"
        v-model="implant.third_party"
        :options="clients"
        :loading="!clients.length"
        :disabled="!clients.length"
        id="_id"
        track-by="_id"
        :custom-label="$clientName"
      >
        <a class="button is-success" href="javascript:void(0)" @click="openNewClient()" disabled><font-awesome-icon icon="plus" class="m-0" /></a>
        <a class="button is-warning" :href="implant.third_party ? '/clienti/'+implant.third_party._id : 'javascript:void(0)'"><font-awesome-icon icon="user" class="m-0" /></a>
      </InputSelect>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    implant: Object,
    clients: Array
  },
  emits: ['update:implant'],

  methods: {

  }
}
</script>